export default "__VITE_ASSET__CcyxRHYf__"